// This file was automatically generated from ptdata.model.note.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.note');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.imo');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.nonvisitNoteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), ' nonvisit note.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.visitNoteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), ' visit note.');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.visitNoteDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.signDate) ? 'Unsigned ' : '', (opt_data.type) ? (soy.$$escapeHtml(opt_data.type.name)? soy.$$escapeHtml(opt_data.type.name).capitalize() : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.importedVisitDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.type.name), ' by ', soy.$$escapeHtml(opt_data.physicianFullName), ' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.nonvisitNoteDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.typeName == 'phone') ? 'Phone Note' : (opt_data.typeName == 'email') ? 'Email Note' : (opt_data.typeName == 'direct' || opt_data.typeName == 'DIRECT') ? 'Direct Message' : 'Non-Visit Note');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.importedNonvisitDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.note.nonvisitNoteDescription(opt_data, output);
  output.append(' by ', soy.$$escapeHtml(opt_data.originalAuthorUserName), ' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.chartFeedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.typeName == 'phone') ? '<div class="el8FeedItemIconPhone"></div>' : (opt_data.typeName == 'email' || opt_data.typeName == 'direct' || opt_data.typeName == 'DIRECT') ? '<div class="el8FeedItemIconEmail"></div>' : '<div class="el8FeedItemIconNote"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.visitNoteHeaderSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var reasonList21334 = opt_data.reasonBullets;
  var reasonListLen21334 = reasonList21334.length;
  for (var reasonIndex21334 = 0; reasonIndex21334 < reasonListLen21334; reasonIndex21334++) {
    var reasonData21334 = reasonList21334[reasonIndex21334];
    output.append((reasonIndex21334 == 0) ? 'cc: ' : '', soy.$$escapeHtml(reasonData21334.text), (reasonIndex21334 == reasonListLen21334 - 1) ? '.' : '; ');
  }
  output.append((opt_data.reasonBullets.length && opt_data.problemBullets.length) ? ' ' : '');
  var problemList21348 = opt_data.problemBullets;
  var problemListLen21348 = problemList21348.length;
  for (var problemIndex21348 = 0; problemIndex21348 < problemListLen21348; problemIndex21348++) {
    var problemData21348 = problemList21348[problemIndex21348];
    output.append(soy.$$escapeHtml(problemIndex21348 + 1), '. ', soy.$$escapeHtml(problemData21348.text), (! (problemIndex21348 == problemListLen21348 - 1)) ? ' ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.visitBullet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.item.text) {
    output.append(soy.$$escapeHtml(opt_data.item.text));
  } else {
    el8.template.util.format.apply({formatting: opt_data.item.documentSummaryFormatting, text: opt_data.item.documentSummary}, output);
  }
  if (opt_data.item.imos && ! opt_data.suppressImoCodes) {
    output.append(' ');
    el8.template.appshared.imo.imoList({imos: opt_data.item.imos, icd10Only: true}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.billCptSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.doHighlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.cpt)) : soy.$$escapeHtml(opt_data.cpt)) : soy.$$escapeHtml(opt_data.cpt));
  el8.template.ptdata.model.note.modifierList(opt_data, output);
  output.append(': <span class="el8Code">[');
  el8.template.ptdata.model.note.dxList(opt_data, output);
  output.append(']</span>', (opt_data.units && opt_data.charge) ? ' ' + soy.$$escapeHtml(opt_data.units) + ' x ' + (soy.$$escapeHtml(opt_data.charge)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.charge)) : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.cptWithModifiers = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.cpt));
  el8.template.ptdata.model.note.modifierList(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.modifierList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.modifier1) ? '-' + soy.$$escapeHtml(opt_data.modifier1) : '', (opt_data.modifier2) ? '-' + soy.$$escapeHtml(opt_data.modifier2) : '', (opt_data.modifier3) ? '-' + soy.$$escapeHtml(opt_data.modifier3) : '', (opt_data.modifier4) ? '-' + soy.$$escapeHtml(opt_data.modifier4) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.dxList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var dxLineList21409 = opt_data.dxs;
  var dxLineListLen21409 = dxLineList21409.length;
  for (var dxLineIndex21409 = 0; dxLineIndex21409 < dxLineListLen21409; dxLineIndex21409++) {
    var dxLineData21409 = dxLineList21409[dxLineIndex21409];
    if (dxLineData21409.icd10Code) {
      output.append('<span class="el8Icd10Code">', soy.$$escapeHtml(dxLineData21409.icd10Code.code), '</span>');
      if (dxLineData21409.icd9Codes && dxLineData21409.icd9Codes.length && opt_data.isShowDualCoding || dxLineData21409.dx) {
        output.append(' (');
        el8.template.ptdata.model.note._icd9DxList(dxLineData21409, output);
        output.append(')');
      }
    } else {
      el8.template.ptdata.model.note._icd9DxList(dxLineData21409, output);
    }
    output.append((! (dxLineIndex21409 == dxLineListLen21409 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note.dxList9Only = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var dxLineList21427 = opt_data.dxs;
  var dxLineListLen21427 = dxLineList21427.length;
  for (var dxLineIndex21427 = 0; dxLineIndex21427 < dxLineListLen21427; dxLineIndex21427++) {
    var dxLineData21427 = dxLineList21427[dxLineIndex21427];
    el8.template.ptdata.model.note._icd9DxList(dxLineData21427, output);
    output.append((dxLineData21427.icd9Codes && dxLineData21427.icd9Codes.length || dxLineData21427.dx) ? (! (dxLineIndex21427 == dxLineListLen21427 - 1)) ? ', ' : '' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.note._icd9DxList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.icd9Codes && opt_data.icd9Codes.length) {
    var icd9List21438 = opt_data.icd9Codes;
    var icd9ListLen21438 = icd9List21438.length;
    for (var icd9Index21438 = 0; icd9Index21438 < icd9ListLen21438; icd9Index21438++) {
      var icd9Data21438 = icd9List21438[icd9Index21438];
      output.append('<span class="el8Icd9Code">', soy.$$escapeHtml(icd9Data21438.code), '</span>', (! (icd9Index21438 == icd9ListLen21438 - 1)) ? ', ' : '');
    }
  } else {
    output.append(soy.$$escapeHtml(opt_data.dx));
  }
  if (!opt_sb) return output.toString();
};
